(() => {
  'use strict';
  if (window.__PIELURD_MINIMAL_MENU_V18__) return;
  window.__PIELURD_MINIMAL_MENU_V18__ = true;

  const SELF_SRC = document.currentScript?.src || '';
  const ACCOUNT_URL = 'https://shopify.com/102547947888/account';
  const ACCOUNT_ICON = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="8" r="3.25" stroke="currentColor" stroke-width="1.45"/><path d="M5.75 20c.35-4.15 2.45-6.25 6.25-6.25S17.9 15.85 18.25 20" stroke="currentColor" stroke-width="1.45" stroke-linecap="round"/></svg>';

  const assetUrl = filename => {
    try {
      const url = new URL(SELF_SRC, location.href);
      url.pathname = url.pathname.replace(/pw18-minimal-menu\.js$/, filename);
      url.search = '';
      return url.href;
    } catch { return ''; }
  };

  const loadFavoritesAssets = () => {
    if (!document.querySelector('link[data-pw19-favorites-style]')) {
      const href = assetUrl('pw19-favorites.css');
      if (href) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.dataset.pw19FavoritesStyle = '';
        document.head.append(link);
      }
    }
    if (!document.querySelector('script[data-pw19-favorites-script]')) {
      const src = assetUrl('pw19-favorites.js');
      if (src) {
        const script = document.createElement('script');
        script.src = src;
        script.dataset.pw19FavoritesScript = '';
        document.head.append(script);
      }
    }
  };

  const init = () => {
    const $ = (selector, root = document) => root?.querySelector(selector) || null;
    const $$ = (selector, root = document) => root ? [...root.querySelectorAll(selector)] : [];
    const root = document.documentElement;
    let header = $('[data-pw18-header]');
    let mega = $('[data-pw18-mega]');
    let mobileMenu = $('[data-pw18-mobile-menu]');
    let frame = 0;

    const isAccountLink = link => {
      try {
        const url = new URL(link.href, location.origin);
        return url.pathname === '/account' || url.pathname.startsWith('/account/') || url.href.startsWith(ACCOUNT_URL);
      } catch {
        return false;
      }
    };

    const ensureAccountLinks = scope => {
      header = $('[data-pw18-header]');
      mega = $('[data-pw18-mega]');
      mobileMenu = $('[data-pw18-mobile-menu]');

      const desktopRight = $('.pw18-header .pw3-header__right');
      if (desktopRight) {
        let accountLink = $$('a[href]', desktopRight).find(isAccountLink);
        if (!accountLink) {
          accountLink = document.createElement('a');
          accountLink.href = ACCOUNT_URL;
          accountLink.className = 'pw3-icon-button pw3-hide-mobile pw18-account-link';
          accountLink.innerHTML = ACCOUNT_ICON;
          const bag = $('[data-pw3-open="cart"]', desktopRight);
          desktopRight.insertBefore(accountLink, bag || null);
        }
        accountLink.dataset.pw18AccountLink = '';
        accountLink.setAttribute('aria-label', 'Hesabım');
        accountLink.setAttribute('title', 'Hesabım');
      }

      const utilities = $('.pw18-mobile-menu__utilities');
      if (utilities) {
        let accountLink = $$('a[href]', utilities).find(isAccountLink);
        if (!accountLink) {
          accountLink = document.createElement('a');
          accountLink.href = ACCOUNT_URL;
          accountLink.innerHTML = `${ACCOUNT_ICON}<span>HESABIM</span>`;
          const localization = $('[data-pw3-open="localization"]', utilities);
          utilities.insertBefore(accountLink, localization || null);
        }
        accountLink.dataset.pw18AccountLink = '';
        accountLink.dataset.pw18MenuLink = '';
        accountLink.setAttribute('aria-label', 'Hesabım ve siparişlerim');
      }
    };

    const setDesktopTop = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!header || matchMedia('(max-width: 900px)').matches) {
          root.style.removeProperty('--pw18-menu-top');
          return;
        }
        const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
        root.style.setProperty('--pw18-menu-top', `${bottom}px`);
      });
    };

    const closeDrawer = drawer => {
      if (!drawer?.classList.contains('is-open')) return;
      drawer.querySelector('[data-pw3-close]')?.click();
    };

    const syncMobileDetail = detail => {
      const summary = $('summary', detail);
      summary?.setAttribute('aria-expanded', String(detail.open));
    };

    const bindMobileGroups = () => {
      const mobileGroups = $$('[data-pw18-mobile-group]');
      mobileGroups.forEach(detail => {
        if (detail.dataset.pw18Bound === 'true') return;
        detail.dataset.pw18Bound = 'true';
        syncMobileDetail(detail);
        detail.addEventListener('toggle', () => {
          syncMobileDetail(detail);
          if (!detail.open) return;
          mobileGroups.forEach(other => {
            if (other !== detail && other.open) other.open = false;
          });
        });
      });

      const currentPath = location.pathname.replace(/\/$/, '') || '/';
      let activeGroup = null;
      mobileGroups.forEach(detail => {
        const active = $$('a[href]', detail).some(link => {
          try {
            const path = new URL(link.href, location.origin).pathname.replace(/\/$/, '') || '/';
            return path === currentPath;
          } catch {
            return false;
          }
        });
        if (active) activeGroup = detail;
      });
      if (activeGroup) {
        mobileGroups.forEach(detail => { detail.open = detail === activeGroup; });
      } else if (!mobileGroups.some(detail => detail.open)) {
        mobileGroups[0]?.setAttribute('open', '');
      }
    };

    const bindDrawerObservers = () => {
      if (mega && mega.dataset.pw18Observed !== 'true') {
        mega.dataset.pw18Observed = 'true';
        const syncMega = () => {
          if (!mega.classList.contains('is-open')) return;
          setDesktopTop();
          mega.scrollTop = 0;
          $('.pw18-mega__shop', mega)?.scrollTo({ top: 0 });
          $('.pw18-mega__secondary', mega)?.scrollTo({ top: 0 });
        };
        new MutationObserver(syncMega).observe(mega, { attributes: true, attributeFilter: ['class'] });
      }

      if (mobileMenu && mobileMenu.dataset.pw18Observed !== 'true') {
        mobileMenu.dataset.pw18Observed = 'true';
        new MutationObserver(() => {
          if (!mobileMenu.classList.contains('is-open')) return;
          $('.pw18-mobile-menu__scroll', mobileMenu)?.scrollTo({ top: 0 });
        }).observe(mobileMenu, { attributes: true, attributeFilter: ['class'] });
      }
    };

    const refresh = scope => {
      loadFavoritesAssets();
      ensureAccountLinks(scope);
      bindMobileGroups();
      bindDrawerObservers();
      setDesktopTop();
    };

    document.addEventListener('click', event => {
      const link = event.target.closest('[data-pw18-menu-link]');
      if (link) {
        const drawer = link.closest('[data-pw3-drawer]');
        if (drawer) closeDrawer(drawer);
      }

      const mobileFavorite = event.target.closest('.pw18-mobile-menu__utilities [data-pw3-favorites]');
      if (mobileFavorite) {
        event.preventDefault();
        document.querySelector('.pw18-header [data-pw3-favorites]')?.click();
      }
    }, true);

    document.addEventListener('shopify:section:load', event => {
      if (!event.target.querySelector?.('[data-pw18-header], [data-pw18-mobile-menu], [data-pw18-mega]')) return;
      requestAnimationFrame(() => refresh(event.target));
    });

    let wasMobile = matchMedia('(max-width: 900px)').matches;
    const onViewportChange = () => {
      setDesktopTop();
      const mobile = matchMedia('(max-width: 900px)').matches;
      if (mobile !== wasMobile) {
        wasMobile = mobile;
        document.querySelector('[data-pw3-drawer].is-open [data-pw3-close]')?.click();
      }
    };

    addEventListener('resize', onViewportChange, { passive: true });
    addEventListener('scroll', setDesktopTop, { passive: true });
    addEventListener('pageshow', () => {
      closeDrawer(mega);
      closeDrawer(mobileMenu);
      refresh(document);
    });

    refresh(document);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
